import { dispatch, ActionType } from './store';
import { ToastOptions, ToastItem, ToastType } from './types';
import { genId } from './utils';

type Message = string;

type ToastHandler = (message: Message, options?: ToastOptions) => string;

const createToast = (
  message: Message,
  type: ToastType,
  option: ToastOptions,
): ToastItem => ({
  id: genId(),
  type,
  message,
  height: 0,
  visible: true,
  ...option,
});

const createHandler =
  (type?: ToastType): ToastHandler =>
  (message, options) => {
    const toast = createToast(message, type, options);
    dispatch({ type: ActionType.OPEN_ALERT, toast });
    return toast.id;
  };

const toast = (message: Message, opts?: ToastOptions) =>
  createHandler('dark')(message, opts);

toast.error = createHandler('danger');
toast.success = createHandler('success');
toast.warn = createHandler('warning');

toast.dismiss = (id: string) => {
  dispatch({
    type: ActionType.CLOSE_ALERT,
    id,
  });
};

export { toast };
